import React, { useState } from 'react';
import { ThumbsUp, MessageSquare } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './ElogiosReclamacoesPage.css';

const ElogiosReclamacoesPage = () => {

  return (
    <div className="elogios-page">
      <SEO 
        title="Elogios, Sugestões e Reclamações"
        description="Envie os seus elogios, sugestões ou reclamações à AASPS. A sua opinião é importante para continuarmos a melhorar."
        url="/elogios-reclamacoes"
      />
      <Header />
      
      {/* Hero Section */}
      <div className="elogios-hero">
        <div className="elogios-hero-content">
          <h1>Elogios, Sugestões e Reclamações</h1>
          <p>A sua opinião é importante para continuarmos a melhorar os nossos serviços.</p>
        </div>
      </div>
      
      <section className="elogios-content">
        <div className="elogios-container">
          <div className="text-content">
            <p className="intro-text">
              A sua opinião é importante para nós. Reclamações e sugestões ajudam-nos a crescer e a 
              melhorar as nossas políticas, processos e sistemas. Da mesma forma, os elogios ajudam-nos 
              a perceber quando estamos a cumprir e a superar os nossos padrões de desempenho e serviço.
            </p>
            
            <p className="info-text">
              As reclamações anónimas são aceites, mas a sua resolução pode por vezes ficar condicionada, 
              por não permitir aferir informação adicional que possa ser importante para a sua resolução. 
              A ausência de contacto impossibilita também a IGAC de transmitir ao reclamante o tratamento 
              e a resolução da situação reportada.
            </p>
          </div>
          
          <div className="buttons-section">
            <a 
              href="https://livrodeelogios.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="livro-button elogios-btn"
            >
              <ThumbsUp size={24} />
              <span>Visite o Livro de Elogios</span>
            </a>
            
            <a 
              href="https://www.livroreclamacoes.pt/inicio" 
              target="_blank" 
              rel="noopener noreferrer"
              className="livro-button reclamacoes-btn"
            >
              <MessageSquare size={24} />
              <span>Visite o Livro de Reclamações</span>
            </a>
          </div>
        </div>
      </section>
      
      <Footer />
      )}
    </div>
  );
};

export default ElogiosReclamacoesPage;
